module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAHVJREFUKBVj/A8EDGQAJjL0gLWMBI0sIJ++fPmCgZGRWO/+ZxATE2dgAEXHypUr/v/584covGrVSpCW/2Abb926xTBjxnQGQUFBvLHz9u07hq9fv4DVMIK1A9MAIyMjXk0wSaB6sFqwRpggKTSxIYJh5kjQCAAyLlWtm0tcVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/banca.png
// module id = 490
// module chunks = 0